document.addEventListener("DOMContentLoaded", function () {
  if (!window.location.pathname.includes("/products/")) return;

  const productData = window.recentlyViewedProduct;
  if (!productData) return;

  let viewed = JSON.parse(localStorage.getItem("stm_recently_viewed")) || [];

  // Remove duplicate
  viewed = viewed.filter(item => item.handle !== productData.handle);

  // Add current product to beginning
  viewed.unshift(productData);

  // Keep only latest 8
  viewed = viewed.slice(0, 8);

  localStorage.setItem(
    "stm_recently_viewed",
    JSON.stringify(viewed)
  );
});